// Dashboard, new project flow, plans and pricing
const dashboard = {
  // Project cards
  'Untitled Project': 'مشروع بدون عنوان',
  'Brouillon': 'مسودة',
  'Failed': 'فشل',
  'Converting media': 'تحويل الملف',
  'Transcribing audio': 'تفريغ الصوت',
  'Refining output': 'تحسين النتيجة',
  'Finalizing': 'اللمسات الأخيرة',
  'Completed': 'مكتمل',

  // Usage / plan card
  'Renews {date}': 'يتجدد في {date}',
  'Resets {date}': 'يُعاد التعيين في {date}',
  'Custom Plan': 'باقة مخصصة',
  'Max Plan': 'باقة Max',
  'Pro Plan': 'باقة Pro',
  'Starter Plan': 'باقة Starter',
  'Trial': 'تجربة مجانية',
  '{count} Bonus Videos': {
    zero: '{count} فيديو إضافي',
    one: 'فيديو إضافي واحد',
    two: 'فيديوهان إضافيان',
    few: '{count} فيديوهات إضافية',
    many: '{count} فيديو إضافي',
    other: '{count} فيديو إضافي',
  },
  'Used first before plan quota': 'تُستخدم قبل رصيد الباقة',
  '{count} expire {date}': {
    zero: 'تنتهي صلاحيتها في {date}',
    one: 'فيديو واحد تنتهي صلاحيته في {date}',
    two: 'فيديوهان تنتهي صلاحيتهما في {date}',
    few: '{count} فيديوهات تنتهي صلاحيتها في {date}',
    many: '{count} فيديو تنتهي صلاحيتها في {date}',
    other: '{count} فيديو تنتهي صلاحيتها في {date}',
  },
  'Trial Videos (Lifetime)': 'فيديوهات التجربة (مدى الحياة)',
  '2 min max per video': 'دقيقتان كحد أقصى لكل فيديو',
  'Remaining': 'المتبقي',
  'min': 'د',
  'Max / video': 'الحد / فيديو',
  'Videos': 'فيديوهات',
  '{used} of {total} used': 'تم استخدام {used} من {total}',
  'Trial credits never expire': 'رصيد التجربة لا ينتهي',
  'Upgrade to Max': 'الترقية إلى Max',
  'Upgrade to Pro': 'الترقية إلى Pro',
  'Upgrade Now': 'قم بالترقية الآن',
  'Subscribe Now': 'اشترك الآن',
  'Settings': 'الإعدادات',
  'Profile, billing, preferences': 'الملف الشخصي، الفوترة، التفضيلات',

  // Sidebar
  'Dashboard': 'لوحة التحكم',
  'Coming Soon': 'قريبًا',
  'Folders': 'المجلدات',
  'Brand Kit': 'هوية العلامة',
  'Soon': 'قريبًا',
  'Open navigation menu': 'فتح القائمة',

  // Announcement + list
  'Research Preview': 'نسخة تجريبية',
  'Welcome to': 'مرحبًا بك في',
  'Join our Whatsapp Community and have exclusive perks and access a vibrant community of creators and professional editors.':
    'انضم إلى مجتمعنا على واتساب واستفد من مزايا حصرية وتواصل مع مجتمع نشيط من صنّاع المحتوى والمونتيرين المحترفين.',
  'Join WhatsApp Community': 'انضم إلى مجتمع واتساب',
  'Search projects...': 'ابحث في المشاريع...',
  'New project': 'مشروع جديد',
  'Your projects ({count})': 'مشاريعك ({count})',
  'Create a project': 'أنشئ مشروعًا',
  'Blank': 'فارغ',
  'Page <b>{page}</b> of {total}': 'صفحة <b>{page}</b> من {total}',
  'Failed to load jobs.': 'تعذّر تحميل المشاريع.',

  // New project modal — processing
  'Complete!': 'اكتمل!',
  'Processing your video': 'جارٍ معالجة الفيديو',
  'Preparing upload...': 'جارٍ تجهيز الرفع...',
  'Submitting transcription...': 'جارٍ إرسال الطلب...',
  'Processing transcription...': 'جارٍ تفريغ النص...',
  'Converting media...': 'جارٍ تحويل الملف...',
  'Transcribing audio...': 'جارٍ تفريغ الصوت...',
  'Refining transcription...': 'جارٍ تحسين النص...',
  'Finalizing output...': 'جارٍ وضع اللمسات الأخيرة...',
  'Converting Media': 'تحويل الملف',
  'Transcribing Audio': 'تفريغ الصوت',
  'Refining Output': 'تحسين النتيجة',
  'Go to Dashboard': 'العودة إلى لوحة التحكم',
  'You can track progress from your dashboard': 'يمكنك متابعة التقدم من لوحة التحكم',
  'Processing failed': 'فشلت المعالجة',
  'Failed to create project.': 'تعذّر إنشاء المشروع.',
  'Failed to get upload URL.': 'تعذّر تجهيز رابط الرفع.',
  'Failed to get upload URL': 'تعذّر تجهيز رابط الرفع',
  'Job created but no ID returned.': 'تم إنشاء المهمة لكن لم يتم استلام معرّفها.',

  // Step 1 — upload
  'Upload your media': 'ارفع الفيديو أو الملف الصوتي',
  'Step {n} of {total}': 'الخطوة {n} من {total}',
  '{size} MB': '{size} ميغابايت',
  'Change file': 'تغيير الملف',
  'Drag and drop or Browse': 'اسحب الملف وأفلته هنا أو تصفّح',
  'MP4, MOV, MP3 · Max 500MB': 'MP4، MOV، MP3 · الحد الأقصى 500 ميغابايت',
  'Or try an example': 'أو جرّب مثالًا',
  '🇲🇦 Darija Mixed with French': '🇲🇦 دارجة ممزوجة بالفرنسية',
  'Selected': 'تم الاختيار',
  'Use This': 'استخدم هذا',
  'Checking...': 'جارٍ التحقق...',
  'Continue': 'متابعة',
  'Back': 'رجوع',
  'Video is {duration} but the maximum allowed duration is {max}. Please trim your video and try again.':
    'مدة الفيديو {duration} والحد الأقصى المسموح به هو {max}. يُرجى قص الفيديو والمحاولة مرة أخرى.',

  // Step 2 — language
  'Choose your language': 'اختر اللغة',
  'Other Languages': 'لغات أخرى',
  'Auto Arabic Dialect': 'تحديد اللهجة تلقائيًا',
  'Moroccan': 'المغربية',
  'Egyptian': 'المصرية',
  'Saudi': 'السعودية',
  'Lebanese': 'اللبنانية',
  'Algerian': 'الجزائرية',
  'Tunisian': 'التونسية',
  'Jordanian': 'الأردنية',
  'Iraqi': 'العراقية',
  'Syrian': 'السورية',
  'Palestinian': 'الفلسطينية',
  'Kuwaiti': 'الكويتية',
  'Qatari': 'القطرية',
  'Bahraini': 'البحرينية',
  'Omani': 'العُمانية',
  'Yemeni': 'اليمنية',
  'Libyan': 'الليبية',
  'Sudanese': 'السودانية',
  'English': 'الإنجليزية',
  'French': 'الفرنسية',
  'Spanish': 'الإسبانية',
  'Portuguese': 'البرتغالية',
  'Language': 'اللغة',

  // Step 3 — script
  'Script style': 'طريقة الكتابة',
  'Standard Arabic': 'حروف عربية',
  'Arabic script transcription': 'كتابة النص بالحروف العربية',
  'Arabizi': 'عربيزي',
  'Beta': 'تجريبي',
  'Latin script transcription': 'كتابة النص بالحروف اللاتينية',
  'Latin script': 'حروف لاتينية',

  // Step 4 — foreign words
  'Foreign words': 'الكلمات الأجنبية',
  'How to handle words from other languages?': 'كيف نتعامل مع الكلمات من لغات أخرى؟',
  'Transliterated': 'بحروف عربية',
  'Write foreign words in Arabic letters (Default)': 'كتابة الكلمات الأجنبية بالحروف العربية (افتراضي)',
  'Code-switched': 'كما هي',
  'Keep foreign words in original script': 'الإبقاء على الكلمات الأجنبية بحروفها الأصلية',
  'Translated': 'مترجمة',
  'Translate foreign words to Arabic': 'ترجمة الكلمات الأجنبية إلى العربية',
  'You can change this later in the editor': 'يمكنك تغيير هذا لاحقًا من المحرر',

  // Step 5 — details
  'Almost there!': 'اقتربنا!',
  'Project Name': 'اسم المشروع',
  'Enter project name...': 'أدخل اسم المشروع...',
  'Advanced Settings': 'إعدادات متقدمة',
  'Chunk by': 'تقسيم حسب',
  'Words': 'الكلمات',
  'Characters': 'الأحرف',
  'Words per chunk': 'عدد الكلمات في كل مقطع',
  'Characters per chunk': 'عدد الأحرف في كل مقطع',
  'Short bursts': 'مقاطع قصيرة',
  'Balanced': 'متوازن',
  'Long phrases': 'جمل طويلة',
  'Compact': 'مختصر',
  'Extended': 'موسّع',
  'Separate foreign words': 'فصل الكلمات الأجنبية',
  'Keep Latin phrases in separate chunks': 'وضع العبارات اللاتينية في مقاطع منفصلة',
  'Split on punctuation': 'التقسيم عند علامات الترقيم',
  'Break phrases at periods, commas, etc.': 'تقسيم الجمل عند النقاط والفواصل وغيرها',
  'Split on silence': 'التقسيم عند التوقف',
  'Break phrases at natural pauses in speech': 'تقسيم الجمل عند التوقفات الطبيعية في الكلام',
  'Latin Script': 'حروف لاتينية',
  'Arabic Script': 'حروف عربية',
  'Translate': 'ترجمة',
  'Keep Latin': 'الإبقاء بالحروف اللاتينية',
  '{language} Transcription': 'تفريغ نصي بـ{language}',
  'Finishing upload...': 'جارٍ إكمال الرفع...',
  'Starting...': 'جارٍ البدء...',
  'Start Transcription': 'ابدأ التفريغ',

  // Manifesto
  'Our Story': 'قصتنا',
  '400 million': '400 مليون',
  'voices.': 'صوت.',
  'Arabic is one of the most spoken languages on Earth.': 'العربية من أكثر اللغات انتشارًا في العالم.',
  'Yet AI barely understands it.': 'ومع ذلك، بالكاد يفهمها الذكاء الاصطناعي.',
  'Small team. Big dream.': 'فريق صغير. حلم كبير.',
  'The Challenge': 'التحدي',
  "Arabic isn't <em>one</em> language.": 'العربية ليست لغة <em>واحدة</em>.',
  "It's dozens.": 'إنها عشرات اللهجات.',
  'Real dialects': 'لهجات حقيقية',
  'Darija. Masri. Khaleeji. Not textbook Arabic.': 'الدارجة. المصرية. الخليجية. وليست عربية الكتب.',
  'Languages blend': 'لغات ممزوجة',
  'Arabic, French, English. One breath.': 'عربية وفرنسية وإنجليزية في جملة واحدة.',
  'Generic AI fails': 'الذكاء الاصطناعي العام يخفق',
  'Tools trained on English miss everything that makes us, us.': 'الأدوات المدرّبة على الإنجليزية تفوّت كل ما يميّزنا.',
  'Our Approach': 'منهجنا',
  'Built <em>different</em>.': 'مبني <em>بشكل مختلف</em>.',
  'For a reason.': 'ولسبب وجيه.',
  'Native dialects': 'لهجات محلية',
  'How you actually speak. Natural. Authentic.': 'كما تتكلم فعلًا. بشكل طبيعي وأصيل.',
  'Language-aware': 'يفهم اللغات',
  'Arabic, French, English — mixed together, understood.': 'العربية والفرنسية والإنجليزية — ممزوجة ومفهومة.',
  'Fast by design': 'سريع بطبيعته',
  'Edit in seconds. Ship faster. Create more.': 'عدّل في ثوانٍ. انشر أسرع. أنتج أكثر.',
  'The Why': 'لماذا؟',
  'Beyond subtitles.': 'أكثر من مجرد ترجمة.',
  'Connection. Access. Opportunity.': 'تواصل. وصول. فرص.',
  'Accessibility': 'إتاحة الوصول',
  'Opening Arabic content to the deaf and hard of hearing. Everyone deserves access.':
    'نجعل المحتوى العربي متاحًا للصم وضعاف السمع. من حق الجميع الوصول إليه.',
  'Literacy': 'محو الأمية',
  'Helping children connect spoken words to written text. Learning by watching.':
    'نساعد الأطفال على الربط بين الكلمة المنطوقة والمكتوبة. التعلّم بالمشاهدة.',
  'Global reach': 'انتشار عالمي',
  'Empowering creators to share their voice with the world.': 'نمكّن صنّاع المحتوى من إيصال صوتهم إلى العالم.',
  'Early Access': 'وصول مبكر',
  'Join the journey.': 'انضم إلى الرحلة.',
  "We're building in public. Learning fast. Shipping faster. And we need you.":
    'نبني بشكل علني. نتعلّم بسرعة. ونطلق أسرع. ونحتاجك معنا.',
  "Shape what's next": 'ساهم في ما هو قادم',
  'Report bugs you find': 'أبلغ عن الأخطاء التي تجدها',
  'Share your ideas': 'شاركنا أفكارك',
  'Tell a creator friend': 'أخبر صديقًا من صنّاع المحتوى',
  'Say hello': 'راسلنا',
  "Let's build": 'لنبدأ',

  // Limit reached
  'Trial Videos Used': 'استُخدمت فيديوهات التجربة',
  "You've used all your trial videos. Upgrade to continue creating amazing content!":
    'لقد استخدمت جميع فيديوهات التجربة. قم بالترقية لمواصلة إنشاء محتوى رائع!',
  'View Plans': 'عرض الباقات',
  'Maybe Later': 'لاحقًا',
  'Monthly Limit Reached': 'وصلت إلى الحد الشهري',
  "You've used all {count} videos for this month. Upgrade to Pro for 30 videos per month!":
    'لقد استخدمت جميع الفيديوهات ({count}) لهذا الشهر. قم بالترقية إلى Pro للحصول على 30 فيديو شهريًا!',
  'Got It': 'حسنًا',
  "You've used all {count} videos for this month. Need more? Upgrade to Max or contact us!":
    'لقد استخدمت جميع الفيديوهات ({count}) لهذا الشهر. تحتاج المزيد؟ قم بالترقية إلى Max أو تواصل معنا!',
  'Upgrade to Max (100 videos)': 'الترقية إلى Max (100 فيديو)',
  'Contact Us on WhatsApp': 'تواصل معنا على واتساب',
  "You've used all {count} videos for this month. Need more? Let's talk about a custom plan!":
    'لقد استخدمت جميع الفيديوهات ({count}) لهذا الشهر. تحتاج المزيد؟ لنتحدث عن باقة مخصصة!',

  // Pricing modal
  'Our Pricing Options': 'باقاتنا وأسعارنا',
  '12 people viewing': '12 شخصًا يشاهدون الآن',
  'Ends Soon': 'ينتهي قريبًا',
  'Special Launch Prices': 'أسعار إطلاق خاصة',
  'Lock in these exclusive rates before they increase': 'احجز هذه الأسعار الحصرية قبل أن ترتفع',
  '<b>47 creators</b> joined this week': 'انضم <b>47 صانع محتوى</b> هذا الأسبوع',
  'Only <b>8 spots</b> left at this price': 'تبقّى <b>8 أماكن</b> فقط بهذا السعر',
  'Perfect for beginner video editors who are just getting started.': 'مثالية للمونتيرين المبتدئين في بداية طريقهم.',
  'Great for active editors working with more clients and content.': 'رائعة للمونتيرين النشطين الذين يعملون مع عملاء ومحتوى أكثر.',
  'Built for professional editors handling large content demands.': 'مصممة للمونتيرين المحترفين الذين يتعاملون مع كميات كبيرة من المحتوى.',
  '8 videos': '8 فيديوهات',
  '30 videos': '30 فيديو',
  '100 videos': '100 فيديو',
  'Up to 2 minutes per video': 'حتى دقيقتين لكل فيديو',
  'Email support': 'دعم عبر البريد الإلكتروني',
  'Priority support': 'دعم ذو أولوية',
  'Dedicated support': 'دعم مخصص',
  '/month': '/شهريًا',
  'Popular': 'الأكثر طلبًا',
  'CURRENT PLAN': 'باقتك الحالية',
  'Processing...': 'جارٍ المعالجة...',
  'GET STARTED': 'ابدأ الآن',
  'GO PRO': 'اشترك في Pro',
  'GET PREMIUM': 'اشترك في Max',
  'Cancel anytime': 'إلغاء في أي وقت',
  'Customer support': 'دعم العملاء',
  '1 video free trial': 'تجربة مجانية بفيديو واحد',
  'Contact us on WhatsApp at <a>+212 691 154 252</a> for a custom offer.':
    'تواصل معنا على واتساب على الرقم <a>+212 691 154 252</a> للحصول على عرض مخصص.',
  'Failed to open billing portal': 'تعذّر فتح بوابة الفوترة',
  'Failed to open billing portal. Please try again.': 'تعذّر فتح بوابة الفوترة. حاول مرة أخرى.',
  'Failed to create checkout session': 'تعذّر بدء عملية الدفع',
  'Failed to process upgrade. Please try again.': 'تعذّرت معالجة الترقية. حاول مرة أخرى.',

  // Plan price strings (src/utils/pricing.js)
  '99 MAD': '99 درهم',
  '189 MAD': '189 درهم',
  '399 MAD': '399 درهم',
  '12.4 MAD per video': '12.4 درهم للفيديو',
  '6.3 MAD per video': '6.3 درهم للفيديو',
  '3.9 MAD per video': '3.9 درهم للفيديو',
  '$1.50 per video': '1.50$ للفيديو',
  '$0.80 per video': '0.80$ للفيديو',
  '$0.45 per video': '0.45$ للفيديو',
};

export default dashboard;
